import LogisticStep2 from "../LogisticBidSubmission/LogisticStep2";

const Step2 = (props) => {
  return <LogisticStep2 {...props} />;
};

export default Step2;
